import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import img from '../../assets/images/403.svg';
import logo from '../../assets/images/403img.svg';
import '../../assets/css/errorpage599.css';

const ErrorPage403 = () => {

    const navigate = useNavigate(); // Initialize navigate hook

    const goHome = () => {
        navigate('/dashboard'); // Navigates to the home page
    };

    return (
        <div>
            <section>
                <div className='container' style={{ marginTop: '198px' }}>
                    <div className="row"  style={{marginTop:'179px'}}>
                        <div className="col-lg-6">
                            <div>
                                <img src={img} alt="Error" />
                                <span>
                                    <p style={{ marginTop: '-39px', marginLeft: '197px' }}>
                                    Forbidden
                                    </p>
                                </span>

                                <div>
                                    <p style={{ fontSize: '30px', fontWeight: '600', color: '#2196F3', marginTop: '56px' }}>
                                    OOPS!
                                    </p>
                                    <p style={{ fontSize: '18px', fontWeight: '500', lineHeight: '32px', color: '#666666', marginTop: '20px' }}>
                                    You don’t have permission to view this page. Let’s get you back to safer ground.
                                    </p>
                                </div>
                                <button
                                    style={{
                                        width: '83px',
                                        height: '37px',
                                        borderRadius: '10px',
                                        color: '#fff',
                                        backgroundColor: '#2196F3',
                                        border: 'none',
                                        marginLeft: '15px',
                                        marginTop: '37px'
                                    }}
                                    onClick={()=>{goHome()}}
                                >
                                  Home
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src={logo} style={{ width: '83%', marginLeft: '103px' }} className='img' alt="Logo" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ErrorPage403;
